<div class="error-container" data-qa-id="error-container">
    <div class="error-icon" data-qa-id="error-icon">
        <mat-icon>sentiment_very_dissatisfied</mat-icon>
    </div>
    <div class="error-content" data-qa-id="error-content">
        <div *ngIf="errorMessage">{{errorMessage}}</div>
        <ng-content></ng-content>
    </div>
</div>